import { LoadingComponent, MasterPage } from "@components";
import React, { useEffect, useState } from "react";
import { ProtocoloEntidade } from "@entidades";
import { Alert, Box, Button } from "@intech/web-ui";
import { ComprovantesService } from "@services";
import { FaSearch } from "react-icons/fa";
import { useHistory } from "react-router";
import { buscarBloqueio, NumFuncionalidade } from "@helpers";

export const Comprovantes: React.FC = ({ ...rest }) => {
  const history = useHistory();

  const [MotivoBloqueio, setMotivoBloqueio] = useState<string>("");
  const [Loading, setLoading] = useState(false);
  const [Erro, setErro] = useState<string>("");

  const [ListaComprovantes, setListaComprovantes] = useState<ProtocoloEntidade[]>([]);

  useEffect(() => {
    (async () => {
      let bloqueio = await buscarBloqueio(NumFuncionalidade.COMPROVANTES);
      if (bloqueio) setMotivoBloqueio(bloqueio);
      // await criarLog(DMN_FUNCIONALIDADE.COMPROVANTES);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        let lista = await ComprovantesService.Buscar();
        setListaComprovantes(lista);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <MasterPage {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type="danger">{Erro}</Alert>}

      {!Loading && MotivoBloqueio && <Alert type="danger">{MotivoBloqueio}</Alert>}

      {!Loading && !Erro && !MotivoBloqueio && ListaComprovantes.length === 0 && <Alert type={"danger"}>{"Você não possui comprovantes para consulta."}</Alert>}

      {!Loading && !Erro && !MotivoBloqueio && ListaComprovantes.length > 0 && (
        <Box>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Data Solicitação</th>
                  <th>Funcionalidade</th>
                  <th>Protocolo</th>
                  <th>Situação</th>
                  <th>Data Efetivação</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {ListaComprovantes.map((comprovante, index) => (
                  <tr key={index}>
                    <td>{comprovante.DTA_SOLICITACAO}</td>
                    <td>{comprovante.DES_FUNCIONALIDADE}</td>
                    <td>{comprovante.COD_IDENTIFICADOR}</td>
                    <td>
                      <strong>
                        {comprovante.DES_SITUACAO === "RECUSADO" && <span className="text-danger">{comprovante.DES_SITUACAO}</span>}
                        {comprovante.DES_SITUACAO === "EFETIVADO" && <span className="text-success">{comprovante.DES_SITUACAO}</span>}
                        {comprovante.DES_SITUACAO === "SOLICITADO" && <span className="text-info">{comprovante.DES_SITUACAO}</span>}
                      </strong>
                    </td>
                    <td>{comprovante.DTA_EFETIVACAO}</td>
                    <td>
                      <Button
                        type="primary"
                        title="Detalhar"
                        icon={<FaSearch />}
                        onClick={() => history.push(`/comprovantesDetalhe/${comprovante.OID_PROTOCOLO}`)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Box>
      )}
    </MasterPage>
  );
};
